export const EXTRACTS_FINAL_AFTER_SHUTDOWN_REQUEST =
	"EXTRACTS_FINAL_AFTER_SHUTDOWN_REQUEST"
export const EXTRACTS_FINAL_AFTER_SHUTDOWN_RECEIVE =
	"EXTRACTS_FINAL_AFTER_SHUTDOWN_RECEIVE"
export const EXTRACTS_FINAL_AFTER_SHUTDOWN_FAILURE =
	"EXTRACTS_FINAL_AFTER_SHUTDOWN_FAILURE"
